export default __webpack_public_path__ + "static/media/img-0108-canada-full-face.dd46ca8c.png";